<template>
  <tela-component title="Sincronizar Dados">
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <template v-else>
      <v-alert v-if="device() > 1" text type="info"
        >Opção não disponível para este dispositivo</v-alert
      >
      <v-progress-linear indeterminate v-else-if="loading"></v-progress-linear>
      <template v-else>
        <v-overlay color="black" v-if="sincronizando" opacity=".75">
          <v-list-item>
            <v-list-item-avatar width="75" height="75" tile>
              <v-progress-circular
                indeterminate
                size="55"
                width="2"
              ></v-progress-circular>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title">{{ msg }}</v-list-item-title>
              <v-list-item-subtitle class="body-1"
                >aguarde...</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-overlay>
        <template v-else>
          <v-card class="mb-3" flat rounded="lg">
            <v-card-title class="font-weight-bold subtitle-1"
              >O que deseja sincronizar?</v-card-title
            >
            <v-card-text>
              <v-list-item v-for="(opcao, i) in recursos_sync" :key="i">
                <v-list-item-avatar>
                  <v-checkbox
                    :disabled="!sincronizouApp()"
                    v-model="opcao.selecionar"
                  ></v-checkbox>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ opcao.opcao }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>

          <v-bottom-navigation absolute dark grow>
            <v-btn
              @click="sincronizarDados()"
              block
              depressed
              class="info white--text subtitle-1"
              :disabled="!online()"
              >Iniciar Sincronização</v-btn
            >
          </v-bottom-navigation>

          <table-pedidos-offline />
          <!--<table-ultimas-sincronizacoes /> -->
        </template>
      </template>
    </template>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import {
  saveConfigPedidos,
  /* getPedidosDB,
  removerPedidoDB,*/
  saveDadosInsumosDB,
} from "@/db/pedidos";
import { saveClientes, saveProdutosPendentes } from "@/db/clientes";
import { saveDadosBase } from "@/db/base";
import {
  getSincronizacoes,
  //getSincronizacoes,
  saveAtalhosIniciais,
  saveSincronizacao,
} from "@/db/sistema";
import TablePedidosOffline from "@/components/sincronizar-dados/TablePedidosOffline.vue";
//import TableUltimasSincronizacoes from "@/components/sincronizar-dados/TableUltimasSincronizacoes.vue";
import moment from "moment";
export default {
  components: {
    TelaComponent,
    TablePedidosOffline,
    // TableUltimasSincronizacoes,
  },
  computed: {
    ...mapState("sync", ["sincronizando"]),
    ...mapState("sistema", ["atalhos"]),
    ...mapState("pedidos", ["produtos", "config"]),
    ...mapState("clientes", ["clientes", "produtosEmAberto"]),
    ...mapState("base", ["filiais"]),
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("insumos", ["produtosDisponiveis", "produtoSelecionado"]),
  },
  data: () => ({
    msg: "",
    erro: false,
    loading: true,
    clientesSinc: [],
    produtosAbertosSinc: [],
    ult_matr: 1,
    recursos_sync: [
      { opcao: "Configurações", selecionar: true },
      { opcao: "Produtos", selecionar: true },
      { opcao: "Clientes", selecionar: true },
    ],
  }),
  methods: {
    ...mapMutations("sync", ["setSincronizar"]),
    ...mapMutations("sistema", ["setMsgError", "setErrorRequest"]),
    ...mapMutations("insumos", [
      "setAtualizarDadosInsumos",
      "setModoBuscaProdutos",
      "setProdutoSelecionado",
    ]),
    ...mapMutations("clientes", ["setClientes"]),
    ...mapMutations("sistema", ["setSincronizacoes"]),
    ...mapMutations("pedidos", ["setNovoPedido"]),
    ...mapActions("pedidos", [
      "getProdutos",
      "getConfigPedidos",
      "salvarPedido",
      "sincronizarPedidos",
    ]),
    ...mapActions("clientes", ["getClientes", "getProdutosEmAberto"]),
    ...mapActions("sistema", ["getAtalhosIniciais"]),
    ...mapActions("base", ["getFiliais"]),
    ...mapGetters("sistema", ["sincronizouApp", "device"]),
    ...mapActions("insumos", [
      "getCulturas",
      "getDadosInsumos",
      "getPedidosComSaldo",
      "getCotacoesOnline",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
    online() {
      return navigator.onLine;
    },
    async sincronizarDados() {
      this.setErrorRequest(false);
      this.setMsgError("");
      this.setSincronizar(true);

      try {
        this.msg = "Buscando dados";
        moment().locale("pt-br");
        var dtiniexec = moment().format("DD-MM-YYYY HH:mm:ss");

        if (this.selecSync("Configurações")) {
          await this.getAtalhosIniciais();
          this.msg = "Buscando configurações";
          await this.getConfigPedidos();
          this.msg = "Buscando outros dados";
          await this.getFiliais();
        }

        if (this.selecSync("produtos")) {
          this.msg = "Buscando produtos";
          await this.getProdutos();
          if (!this.usuarioLogado.vendedor_coasul) {
            this.msg = "Buscando produtos em aberto";
            await this.getProdutosEmAberto({ sync: true, ult_matr: 0 });
          }
        }

        if (this.selecSync("clientes")) {
          this.msg = "Buscando clientes";
          this.clientesSinc = [];
          this.ult_matr = 1;
          while (this.ult_matr > 0) {
            this.setClientes(
              await this.getClientes({
                pesquisa: "",
                sync: true,
                ult_matr: this.ult_matr,
              })
            );
            if (this.clientes.length > 0) {
              this.clientes.forEach((cli) => {
                this.clientesSinc.push(cli);
                this.ult_matr = cli.matricula;
              });
            } else {
              this.ult_matr = 0;
            }
            this.msg = `Buscando clientes ${this.ult_matr}`;
          }
        }

        if (this.usuarioLogado.vendedor_coasul) {
          var produtosAux = [];
          this.clientesSinc.sort((a, b) => a.nome.localeCompare(b.nome));

          const totalClientes = this.clientesSinc.length;

          for (let i = 0; i < totalClientes; i++) {
            const cli = this.clientesSinc[i];
            const porcentagem = Math.round(((i + 1) / totalClientes) * 100);

            this.msg = `[${porcentagem}%] Buscando produtos em aberto - ${cli.nome} (${cli.matricula})`;

            await this.getProdutosEmAberto({
              sync: true,
              ult_matr: 0,
              pesquisa: cli.matricula,
            });
            this.produtosEmAberto.forEach((p) => produtosAux.push(p));
          }
          this.produtosEmAberto = produtosAux;
        }

        if (this.selecSync("dados insumos")) {
          if (this.usuarioLogado.vendedor_coasul) {
            this.msg = "Buscando dados insumos";
            this.setAtualizarDadosInsumos(true);

            this.msg = "Buscando dados insumos - culturas";
            await this.getCulturas();

            this.setModoBuscaProdutos("sync");
            this.msg = "Buscando dados insumos - produtos";
            await this.getDadosInsumos();

            const chaves = Object.keys(this.produtosDisponiveis);
            const totalProdutos = chaves.length;

            for (let i = 0; i < totalProdutos; i++) {
              const key = chaves[i];
              const produto = this.produtosDisponiveis[key];
              const porcentagem = Math.round(((i + 1) / totalProdutos) * 100);

              this.msg = `[${porcentagem}%] Buscando dados insumos - ${produto.descricao}`;
              this.setProdutoSelecionado(produto);
              await this.getCotacoesOnline();
              this.produtosDisponiveis[key] = this.produtoSelecionado;
            }
            this.setModoBuscaProdutos("");

            await this.getPedidosComSaldo();
            this.setAtualizarDadosInsumos(false);
          }
        }

        this.msg = "Salvando dados";

        if (this.selecSync("configurações")) {
          /*Salvar Database offline*/
          await saveAtalhosIniciais(this.atalhos);

          this.msg = "Salvando configurações";
          await saveConfigPedidos(this.config);

          this.msg = "Salvando outros dados";
          var dadosBaseSalvar = {
            filiais: this.filiais,
          };
          await saveDadosBase(dadosBaseSalvar);
        }

        if (this.selecSync("produtos")) {
          this.msg = "Salvando produtos em aberto";
          await saveProdutosPendentes(this.produtosEmAberto);
        }

        if (this.selecSync("clientes")) {
          this.msg = "Salvando clientes";
          await saveClientes(this.clientesSinc);
        }

        this.msg = "Salvando pedidos";
        await this.sincronizarPedidos();

        /*
        var pedidosSync = await getPedidosDB("pedidos");
        for (const ped of pedidosSync) {
          if (moment().isAfter(moment(ped.datahoravalidade))) {
            await removerPedidoDB(ped.id_db, "pedidos");
          } else {
            this.setNovoPedido(ped);
            var resPed = await this.salvarPedido();
            if (resPed.id > 0) {
              await removerPedidoDB(ped.id_db,"pedidos");
            }
          }
        }*/

        if (this.selecSync("dados insumos")) {
          if (this.usuarioLogado.vendedor_coasul) {
            this.msg = "Salvando dados insumos";
            await saveDadosInsumosDB({
              culturas: this.$store.state.insumos.culturas,
              filiais: this.$store.state.insumos.filiais,
              produtos: this.$store.state.insumos.produtosDisponiveis,
              config: this.$store.state.insumos.config,
              pedidos: this.$store.state.insumos.pedidosComSaldo,
            });
          }
        }

        this.msg = "Finalizando...";
        await saveSincronizacao({
          codvendedor: this.usuarioLogado.representante
            ? this.usuarioLogado.codrepresentante
            : 0,
          data: moment().format("YYYY-MM-DD"),
          datainiexec: dtiniexec,
          datafimexec: moment().format("DD-MM-YYYY HH:mm:ss"),
        });

        this.$router.push("/");
      } catch (error) {
        this.setErrorRequest(true);
        this.setMsgError(
          `Houve um erro ao sincronizar: ${error}. Tente novamente!`
        );
      } finally {
        this.msg = "";
        this.setSincronizar(false);
      }
    },
    setPassosSync(value) {
      sessionStorage.setItem("sync", value);
    },
    selecSync(param) {
      return (
        this.recursos_sync.findIndex(
          (rs) => rs.opcao.toLowerCase() == param.toLowerCase() && rs.selecionar
        ) >= 0
      );
    },
  },
  async mounted() {
    this.loading = true;
    this.setSincronizacoes(await getSincronizacoes());
    if (this.usuarioLogado.vendedor_coasul) {
      this.recursos_sync.push({
        opcao: "Dados Insumos",
        selecionar: true,
      });
    }
    this.loading = false;
  },
  /*async mounted() {
    this.loading = true;
    this.setSincronizacoes(await getSincronizacoes());
    this.loading = false;

    if (!this.sincronizouApp()) {
      await this.sincronizarDados();
    }
  },*/
};
</script>

<style>
</style>
